// extracted by mini-css-extract-plugin
export var highlightFade = "_36-4";
export var highlighted = "_36-3";
export var table = "_36-1";
export var tableContainer = "_36-0";
export var totalsRow = "_36-2";